import { MissingImage } from 'customizations'
import { withErrorBoundary, Formatter, Modal } from 'shared'
import { User } from 'api'
import { SmartButtonStub } from 'ui/smart-buttons'
import { useEffect, useState } from 'react'

const GuestSignupModal = () => {
  const [approvalPending, setApprovalPending] = useState();
  const [errors, setErrors] = useState(null);
  const [settings, setSettings] = useState({});
  const [submitting, setSubmitting] = useState(false);
  const [success, setSuccess] = useState(false);
  const [user, setUser] = useState({ email: '', phone: '', first_name: '', last_name: '' });

  useEffect(() => loadData(), []);

  const inputChanged = (e) => {
    const { name, value } = e.target;
    setUser({ ...user, [name]: value });
    setErrors(null);
  };

  const loadData = () => {
    setSettings(App.guestPassSettings);
  };

  const submit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      const response = await Backend.post('/users', { user, guest_mode: true });
      if (response.user?.token) {
        User.signIn(response.user);
        const { afterSignupPath = '/home' } = appState.objects;
        setTimeout(() => {
          window.location = `/app/${afterSignupPath}`;
          window.location.reload();
        }, 1500);
      }
      setSuccess(true);
      setApprovalPending(response.pending);
      setErrors(null);
    } catch (xhr) {
      if (xhr.status >= 400 && xhr.status <= 499) {
        setErrors(xhr.responseJSON.errors);
      }
    } finally {
      setSubmitting(false);
    }
  };

  const renderForm = () => (
    <form className="signup--form mx-auto" onSubmit={submit}>
      <p dangerouslySetInnerHTML={{ __html: Formatter.simpleFormat(settings.form_text) }}></p>
      {errors && errors.map((error) => <p key={error} className="alert alert-danger alert-mini text-center">{error}</p>)}
      <div className="row">
        <div className="col-sm-6">
          <div className="form-group">
            <label htmlFor="signup--first-name">First Name</label>
            <input type="text" className="form-control" id="signup--first-name" name="first_name" value={user.first_name} onChange={inputChanged} />
          </div>
        </div>
        <div className="col-sm-6">
          <div className="form-group">
            <label htmlFor="signup--last-name">Last Name</label>
            <input type="text" className="form-control" id="signup--last-name" name="last_name" value={user.last_name} onChange={inputChanged} />
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-sm-6">
          <div className="form-group">
            <label htmlFor="signup--email">Email Address</label>
            <input type="email" className="form-control" id="signup--email" name="email" value={user.email} onChange={inputChanged} />
          </div>
        </div>
        <div className="col-sm-6">
          <div className="form-group">
            <label htmlFor="signup--phone">Phone Number</label>
            <input type="tel" className="form-control" id="signup--phone" name="phone" value={user.phone} onChange={inputChanged} />
          </div>
        </div>
      </div>
      <div className="form-actions text-center">
        <SmartButtonStub text="Sign Up" buttonType="submit" className="inverted primary" spinning={submitting} style={{ width: '120px' }} />
      </div>
    </form>
  );

  const renderSuccess = () => (
    <p className="alert alert-success text-center">
      {`Thank you! Please check your email for instructions on how to access your ${App.guestPassSettings.name} on the ${App.assets.get('app_name')} app.`}
    </p>
  );

  return (
    <div className="GuestSignupModal custom-modal">
      <div className="modal-head">
        <img className="modal-image" src={MissingImage} />
        <img className="modal-image-preview" src={MissingImage} />
        <div className="modal-titlebar">
          <h3 className="modal-title text-center">{`Register Your ${App.guestPassSettings.name}`}</h3>
          <div className="modal-titlebar-actions"></div>
        </div>
        <Modal.CloseButton />
      </div>
      <div className="modal-body">
        <div className="w-100">
          {success ? renderSuccess() : renderForm()}
        </div>
      </div>
    </div>
  );
};

export default withErrorBoundary(GuestSignupModal);
